import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/scheppach_diy_head_online_garantie.svg")